import { URLS } from 'modules/axios'
import useApi from 'composables/useApi'

export function assessmentService() {
  const api = () => useApi()

  function getAssessment(id) {
    return api().query(`${URLS.assessment}${id}/`)
  }

  function getAllAssessments(url = null) {
    return api().query(url || `${URLS.assessment}?page_size=10`)
  }

  return {
    getAssessment,
    getAllAssessments,
  }
}
